// lib/space-types.js — single source of truth for the four Space types.
//
// The internal value (the `space_type` column in the DB and routing logic)
// stays the same so existing data and handlers don't break. Only the
// LABEL the user sees can change here. Any UI that displays a space type
// (cards, modals, badges) should import from this file.
//
// Used by:
//   - features/workspace.js (cards) — Workspace is the unified surface
//     after the Space panel was deleted in Phase 1+2 cleanup
//   - components/invite-modal.js (the type picker)
//   - any future modal that shows a space type
//
// To rename a type label or change a color: edit ONLY this file.

export const SPACE_TYPES = {
  space: {
    id: 'space',
    label: 'Space',
    color: '#c8a96e', // gold
    desc: 'Open collaboration. Shift stays silent unless asked.',
  },
  professional: {
    id: 'professional',
    label: 'Professional',
    color: '#7a9e82', // sage green
    desc: 'Structured roles (coach, manager, mentor). Shift observes.',
  },
  facilitated: {
    id: 'facilitated',          // internal value stays 'facilitated' for backward compat
    label: 'Tutor',              // user-facing label
    color: '#4db8b8',            // teal
    desc: 'Shift tutors your invitee. You observe and guide.',
  },
  private: {
    id: 'private',
    label: 'Private',
    color: '#9b8fc4', // purple
    desc: 'Nothing stored after the session ends.',
  },
};

// Order in which types appear in the picker UI
export const SPACE_TYPE_ORDER = ['space', 'professional', 'facilitated', 'private'];

// Lookup helper. Falls back to 'space' if the value is unknown or missing
// (which is how legacy/null space_type rows in the DB get rendered).
export function getSpaceType(value) {
  return SPACE_TYPES[value] || SPACE_TYPES.space;
}
